import { api } from "../lib/api";
import type { Job } from "./bank";

export type InvoiceImportStatus = "pending_review" | "committed" | "discarded";

export interface InvoiceImport {
  id: string;
  filename: string;
  row_count: number;
  imported_count: number;
  skipped_count: number;
  clients_created: number;
  projects_created: number;
  status: InvoiceImportStatus;
  period_start: string | null;
  period_end: string | null;
  created_at: string;
  updated_at: string;
}

export interface InvoiceImportRow {
  row_number: number;
  client_name: string;
  project_name: string | null;
  invoice_number: string;
  issue_date: string | null;
  due_date: string | null;
  description: string;
  net_amount: string | null;
  vat_rate: string | null;
  currency: string | null;
  kind: string;
  /** Computed by the server from net_amount/vat_rate — any figure stated in the file is
   * cross-checked against these, never stored. */
  derived_vat_amount: string | null;
  derived_total: string | null;
  is_duplicate: boolean;
  is_duplicate_in_file: boolean;
  will_import: boolean;
  will_create_client: boolean;
  will_create_project: boolean;
  errors: string[];
  warnings: string[];
}

export interface InvoiceImportPreview {
  invoice_import: InvoiceImport;
  rows: InvoiceImportRow[];
  new_client_names: string[];
  new_project_names: string[];
  will_import_count: number;
  error_count: number;
  duplicate_count: number;
}

/** No company_id: the template is the same blank workbook for every company, so unlike
 * the statement-import download this endpoint doesn't scope to one. */
export function invoiceImportTemplateUrl(): string {
  return "/api/invoices/import/template";
}

export function uploadInvoiceImport(file: File): Promise<InvoiceImportPreview> {
  return api.upload<InvoiceImportPreview>("/api/invoices/import", file);
}

export function commitInvoiceImport(importId: string): Promise<Job> {
  return api.post<Job>(`/api/invoices/import/${importId}/commit`);
}

export function discardInvoiceImport(importId: string): Promise<InvoiceImport> {
  return api.post<InvoiceImport>(`/api/invoices/import/${importId}/discard`);
}
